import React from 'react';
import { _ } from '../../../functions/translator';

class LevelInfo extends React.Component{

    render(){

        let levelId = this.props.cardsGroup.attributes.level_id
        let level = null
        if (levelId) {
            level = this.props.levels[levelId.toString()]
        }
        let levelValue = level ? level.attributes.name : _('Ninguno')
        
        let levelTitle = _("Plano")
        if (this.props.customcard) {
            if (!this.props.customcard.attributes.level_id) return <div></div>
            levelTitle = this.props.customcard.attributes.level_id
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ levelTitle }</p>
                <span className='text card-description'>{ levelValue }</span>
            </div>
        );
    }
}

export default LevelInfo;